var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34.469,
    viewBox: "0 0 41.659 34.469",
    width: 41.659,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.44.441a17.307 17.307 0 0 1 -5.449 2.185 8.644 8.644 0 0 0 -14.586 8.115 24.511 24.511 0 0 1 -17.944-8.731 8.647 8.647 0 0 0 2.859 11.49 8.609 8.609 0 0 1 -3.928-1.017v.109a8.643 8.643 0 0 0 7.065 8.354 8.659 8.659 0 0 1 -2.27.338 8.527 8.527 0 0 1 -1.626-.128 8.643 8.643 0 0 0 8.163 5.865 17.34 17.34 0 0 1 -10.662 3.869 17.619 17.619 0 0 1 -2.062-.09 24.438 24.438 0 0 0 13.3 3.664c15.882-.257 24.353-13.557 24.167-24.964-.007-.375-.021-.746-.043-1.118a17.575 17.575 0 0 0 4.235-4.539 17.3 17.3 0 0 1 -4.937 1.437 8.667 8.667 0 0 0 3.718-4.839",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.a835cd4370f88576230a6d9b6045d2f3.svg";
export { ForwardRef as ReactComponent };